import React, { useState } from 'react';
import styles from './AddCategoryModal.module.css';

const AddCategoryModal = ({ isOpen, onClose, onSave }) => {
    const [categoryName, setCategoryName] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [isDragging, setIsDragging] = useState(false);

    if (!isOpen) return null;

    const handleImageChange = (file) => {
        if (file && file.type.startsWith('image/')) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        handleImageChange(file);
    };

    const handleFileInput = (e) => {
        const file = e.target.files[0];
        handleImageChange(file);
    };

    const removeImage = () => {
        setImageFile(null);
        setImagePreview(null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (categoryName.trim()) {
            onSave(categoryName, imageFile);
            setCategoryName('');
            setImageFile(null);
            setImagePreview(null);
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2>Agregar Nueva Categoría</h2>
                    <button className={styles.closeButton} onClick={onClose}>✕</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={styles.formGroup}>
                        <label htmlFor="categoryName">Nombre de la Categoría</label>
                        <input
                            type="text"
                            id="categoryName"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Ej: Electrónica"
                            required
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label>Imagen de la Categoría (Opcional)</label>
                        {!imagePreview ? (
                            <div
                                className={`${styles.dropZone} ${isDragging ? styles.dragging : ''}`}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                                onClick={() => document.getElementById('imageInput').click()}
                            >
                                <p>📁 Arrastra una imagen aquí o haz clic para seleccionar</p>
                                <p className={styles.supportedFormats}>PNG, JPEG, GIF, WebP</p>
                            </div>
                        ) : (
                            <div className={styles.imagePreview}>
                                <img src={imagePreview} alt="Preview" />
                                <button type="button" className={styles.removeImageButton} onClick={removeImage}>
                                    ✕ Quitar imagen
                                </button>
                            </div>
                        )}
                        <input
                            type="file"
                            id="imageInput"
                            accept="image/png,image/jpeg,image/jpg,image/gif,image/webp"
                            onChange={handleFileInput}
                            style={{ display: 'none' }}
                        />
                    </div>
                    <div className={styles.formActions}>
                        <button type="button" className={styles.cancelButton} onClick={onClose}>Cancelar</button>
                        <button type="submit" className={styles.submitButton}>Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddCategoryModal;
